import React from 'react';
import { componentService } from 'js/services/component.service';

export const GamesGrid = React.lazy(() => import(/* webpackChunkName: "games-grid" */ './GamesGrid').then((module) => ({ default: module.GamesGrid })));
export const GamesGridViewMore = React.lazy(() => import(/* webpackChunkName: "games-grid-view-more" */ './GamesGrid').then((module) => ({ default: module.GamesGridViewMore })));

componentService.registerPageComponents({ 'games-grid': GamesGrid });
componentService.registerPageComponents({ 'games-grid-view-more': GamesGridViewMore });
